export default "/images/chevron-down-outlined.svg";